const paths = {
  aviso: "/aviso",

  sysConfig: "/sysConfig",

  relatorio: "/relatorios",
  
  bancoImagem: "/bancoimagem",
  bancoImagemCategoria: "/bancoimagemcategoria",

  bannerLogin: "/bannerlogin",

  usuario: "/usuario",
  usuarioTipo: "/usuariotipo",
  usuarioMeusDados: "/meusdados",

  regional: "/regional",
  regionalVerba: "/regional-verba",

  canal: "/canal",
  canalAprovador: "/canal-aprovador",

  loja: "/loja",
  materialcomunicacao: "/materialcomunicacao",
  materialcomunicacaoTipo: "/materialcomunicacaotipo",
  fornecedor: "/fornecedor",

  unidade: "/unidade",

  chamadotipo: "/chamadotipo",

  pedidotipo: "/pedidotipo",

  perguntafrequente: "/perguntafrequente",

  produto: "/produto",
  produtoCategoria: "/produtocategoria",

  produtoatividade: "/produtoatividade",
  
  fluxo: "/fluxo",

  formaPagamento: "/formapagamento",

  motivoAcao: "/motivoacao",

  acaoPromocionalCategoria: "/acaoPromocionalCategoria",
  acaoPromocionalCampoTipo: "/acaoPromocionalCampoTipo",    
  acaoPromocionalCampo: "/acaoPromocionalCampo",  
  acaoPromocional: "/acaoPromocional",

  extratos: "/extrato",
  extratoUsuarios: "/extrato/usuarios",
  extratoLojas: "/extrato/lojas",
  extratoProdutos: "/extrato/produtos",

  valorDiagramacao: "/valordiagramacao",
  valorFrete: "/valorfrete",
  valorProducao: "/valorproducao",

  layoutArte: "/layoutarte",
  campanha: "/campanha",
  rede: "/rede",
  solicitacao: "/solicitacao",

  etapalabel: "/etapalabel",

  solicitacaoAlterar: "/solicitacao/alterar",
  solicitacaoAlterarDados: "/solicitacao/alterar-dados",
  solicitacaoAlterarEntrega: "/solicitacao/alterar-entrega",
  solicitacaoAlterarProdutos: "/solicitacao/alterar-produtos",
  solicitacaoVoltarEtapa: "/solicitacao/voltar-etapa",

  solicitacaoValores: "/solicitacao/valores",
}

export default paths;